import React, { useState, useEffect } from 'react';
import opentype from "opentype.js";
/*
const VectorText = ({  text = "Hello",
  fontUrl = "/fonts/Verdana.ttf",
  x = 0,
  y = 72,
  fontSize = 12,
  fontWeight = null,
  fill = "black",
  rotate }) => {

  
    while (text.length < 30) {
      text = " "  + text
    }
  const [d, setD] = useState("");


  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(fontUrl, { mode: "cors" });
        if (!res.ok) throw new Error(`HTTP ${res.status} for ${fontUrl}`);

        const ct = res.headers.get("content-type") || "";
        if (ct.includes("text/html")) {
          throw new Error(
            `Expected a font, got HTML (${ct}). Check the URL/route/CORS.`
          );
        }

        const buf = await res.arrayBuffer();
        const font = opentype.parse(buf); // parse from buffer avoids XHR quirks
        const path = font.getPath(text, x, y, fontSize);
        if (!cancelled) setD(path.toPathData());
      } catch (err) {
        console.error("Font load error:", err);
      }
    })();

    return () => { cancelled = true; };
  }, [text, fontUrl, x, y, fontSize]);

  const transform = rotate
    ? `rotate(${rotate.angle}, ${rotate.cx ?? 0}, ${rotate.cy ?? 0})`
    : undefined;

  return (
   
      <path d={d} fill={fill} transform={transform} stroke="black"
  strokeWidth={fontWeight === "bold" ? "1" : "0.5"}   // adds thickness around edges
  strokeLinejoin="round"
  strokeLinecap="round" />
   
  );
}
*/



// --- simple cache so fonts load once per URL ---
const fontCache = {};

const VectorText = ({
  text = "Hello",
  fontUrl = "https://apps.windrose.echo-cms.be/fonts/verdana.ttf",
  x = 0,
  y = 72,
  flip = false,
  fontSize = 12,
  fontWeight = null, // "bold" or null
  fill = "black",
  rotate = null,     // { angle, cx, cy }
  align = "left",    // "left" | "center" | "right"
}) => {
  const [d, setD] = useState("");

  if (rotate && rotate.angle) {
    y += 4;
    if (flip) {

      x += 70;
      align = "right";

    } else {
      x -= 70;
    }
  }
  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        // ---- load or reuse cached font ----
        if (!fontCache[fontUrl]) {
          const res = await fetch(fontUrl);
          if (!res.ok) throw new Error(`HTTP ${res.status} for ${fontUrl}`);

          const ct = res.headers.get("content-type") || "";
          if (ct.includes("text/html")) {
            throw new Error(
              `Expected a font, got HTML (${ct}). Check the URL/route/CORS.`
            );
          }

          const buf = await res.arrayBuffer();
          fontCache[fontUrl] = opentype.parse(buf);
        }

        const font = fontCache[fontUrl];

        // pad your text as before
        let paddedText = text;

        if (fontWeight === "bold") {
          while (paddedText.length < 30) {
            paddedText = " " + paddedText;
          }
        }


        // compute width for alignment
        const glyphs = font.stringToGlyphs(paddedText);
        const scale = fontSize / font.unitsPerEm;
        const textWidth = glyphs.reduce(
          (acc, g) => acc + g.advanceWidth * scale,
          0
        );

        let drawX = x;
        if (align === "center") drawX = x - textWidth / 2;
        if (align === "right") drawX = x - textWidth;

        // make the path
        const path = font.getPath(paddedText, drawX, y, fontSize);
        const pathData = path.toPathData();

        if (!cancelled) setD(pathData);
      } catch (err) {
        console.error("Font load error:", err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [text, fontUrl, x, y, fontSize, align, fontWeight]);

  // --- build transform string ---
  const transform = rotate
    ? `rotate(${rotate.angle}, ${rotate.cx ?? x}, ${rotate.cy ?? y})`
    : undefined;

  if (fontWeight === "bold") {
    return (
      <path
        d={d}
        fill={fill}
        transform={transform}
        stroke={fill}
        strokeWidth={"1.2"}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    );

  } else {
    return (
      <path
        d={d}
        fill={fill}
        transform={transform}

      />
    );
  }

};

const Slice = ({ slices, categories, startCategories, handleMouseEnter, handleClick, handleMouseLeave }) => {


  const rotateAll = 158;
  const radius = 200;
  const cx = 275;
  const cy = 245;
  const wedgeAngle = 360 / Object.keys(slices).length;


  const startAngle = 0;
  const endAngle = 359.9;
  const largeArcFlag = 1;


  const x1 = cx + radius * Math.cos((Math.PI / 180) * startAngle);
  const y1 = cy + radius * Math.sin((Math.PI / 180) * startAngle);
  const x2 = cx + radius * Math.cos((Math.PI / 180) * endAngle);
  const y2 = cy + radius * Math.sin((Math.PI / 180) * endAngle);

  const pathData = `
      M ${cx} ${cy}
      L ${x1} ${y1}
      A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}
      Z
    `;

  return (
    <>




      {Object.keys(categories).map((key, index) => {



        const categoryStartAngle = categories[key].startAngle + rotateAll;
        const categoryEndAngle = categoryStartAngle + categories[key].radius;
        const categoryLargeArcFlag = categories[key].radius > 180 ? 1 : 0;

        // Apply the scale factor to the radius
        const categoryScaleFactor = categories[key].transform; // Assuming transform is the scale factor
        const categoryScaledRadius = radius * categoryScaleFactor;

        const categoryX1 = cx + categoryScaledRadius * Math.cos((Math.PI / 180) * categoryStartAngle);
        const categoryY1 = cy + categoryScaledRadius * Math.sin((Math.PI / 180) * categoryStartAngle);
        const categoryX2 = cx + categoryScaledRadius * Math.cos((Math.PI / 180) * categoryEndAngle);
        const categoryY2 = cy + categoryScaledRadius * Math.sin((Math.PI / 180) * categoryEndAngle);

        const categoryPathData = `
  M ${cx} ${cy}
  L ${categoryX1} ${categoryY1}
  A ${categoryScaledRadius} ${categoryScaledRadius} 0 ${categoryLargeArcFlag} 1 ${categoryX2} ${categoryY2}
  Z
`;

        return (
          <>
            <path
              key={"category_" + key}
              d={categoryPathData}
              stroke="#FFFFFF"
              strokeWidth="2"
              fill={categories[key].fill}
              onMouseEnter={(e) => handleMouseEnter(e, key)}
              onMouseLeave={handleMouseLeave}
            />


          </>
        );
      })}

      <path
        key={"circle"}
        d={pathData}
        fill={"rgba(255,255,255, 0.2)"}
        transform-origin={cx + " " + cy}
        style={{ transform: 'scale(1)' }}

      />
      {Object.keys(slices).map((key, index) => {

        const startAngle = (index) * wedgeAngle + rotateAll;


        const endAngle = startAngle + wedgeAngle;
        const largeArcFlag = wedgeAngle > 180 ? 1 : 0;

        const x1 = cx + radius * Math.cos((Math.PI / 180) * startAngle);
        const y1 = cy + radius * Math.sin((Math.PI / 180) * startAngle);
        const x2 = cx + radius * Math.cos((Math.PI / 180) * endAngle);
        const y2 = cy + radius * Math.sin((Math.PI / 180) * endAngle);

        const pathData = `
            M ${cx} ${cy}
            L ${x1} ${y1}
            A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}
            Z
          `;

        const textAngle = startAngle + wedgeAngle / 2;



        let textX = cx + (radius - 100) * Math.cos((Math.PI / 180) * textAngle);
        let textY = cy + (radius - 100) * Math.sin((Math.PI / 180) * textAngle);



        let adjustedTextAngle = textAngle;
        //if (textAngle > 90  && textAngle < 270 ) {
        //   adjustedTextAngle += 180; // Flip the text
        // }

        let flip = false;
        if (textAngle > 450 || textAngle < 255) {
          flip = true;
          adjustedTextAngle += 180; // Flip the text
        } else {
          // textX = textX - 100;
        }


        const sliceScaleFactor = slices[key].transform; // Assuming transform is the scale factor

        const sliceStartAngle = index * wedgeAngle + rotateAll;
        const sliceEndAngle = sliceStartAngle + wedgeAngle;
        const sliceLargeArcFlag = wedgeAngle > 180 ? 1 : 0;

        // Apply the scale factor to the radius
        const sliceScaledRadius = radius * sliceScaleFactor;

        const sliceX1 = cx + sliceScaledRadius * Math.cos((Math.PI / 180) * sliceStartAngle);
        const sliceY1 = cy + sliceScaledRadius * Math.sin((Math.PI / 180) * sliceStartAngle);
        const sliceX2 = cx + sliceScaledRadius * Math.cos((Math.PI / 180) * sliceEndAngle);
        const sliceY2 = cy + sliceScaledRadius * Math.sin((Math.PI / 180) * sliceEndAngle);

        const slicePathData = `
  M ${cx} ${cy}
  L ${sliceX1} ${sliceY1}
  A ${sliceScaledRadius} ${sliceScaledRadius} 0 ${sliceLargeArcFlag} 1 ${sliceX2} ${sliceY2}
  Z
`;



        return (

          <>
            <path
              key={"slice_" + key}
              d={slicePathData}
              stroke="#FFF"
              strokeWidth="2"
              fill={slices[key].fill}
              onMouseEnter={(e) => handleMouseEnter(e, key)}
              onClick={(e) => handleClick(e, null, key)}
              onMouseLeave={handleMouseLeave}
            />




            <path
              key={"circle_" + key}
              d={pathData}
              fill={'rgba(255,255,255,0.0)'}
              stroke="#FFF"
              strokeWidth="2"

              transform-origin={cx + " " + cy}
              style={{ cursor: "Pointer", transform: 'scale(1)' }}
              onMouseEnter={(e) => handleMouseEnter(e, key)}
              onClick={(e) => handleClick(e, null, key)}
              onMouseLeave={handleMouseLeave}
            />



            <VectorText
              x={textX}
              y={textY}
              flip={flip}

              text={slices[key].question}
              rotate={{ "angle": adjustedTextAngle, "cx": textX, "cy": textY }}
              textAnchor="middle"
              fill="#000"
              transform={`rotate(${adjustedTextAngle}, ${textX}, ${textY})`} // Rotate the text*/

              fontSize="12"
            >
              {slices[key].question}
            </VectorText>
          </>

        );
      })}



      {Object.keys(categories).map((key, index) => {



        let score = categories[key].score;

        if (score) {
          score *= 10;
        }

        const startAngle = categories[key].startAngle + rotateAll;

        // Calculate text position
        const textAngle = startAngle + categories[key].radius / 2;
        let textX = cx + (radius + 15) * Math.cos((Math.PI / 180) * textAngle);
        let textY = cy + (radius + 15) * Math.sin((Math.PI / 180) * textAngle);

        let adjustedTextAngle = textAngle;


        if (textAngle > 400) {
          adjustedTextAngle += 180; // Flip the text
        } else {

        }

        adjustedTextAngle += 90;
        adjustedTextAngle = 0;

        if (key == 1) {
          textY = 30;
          textX = 50;
        } else if (key == 2) {
          textY = 175;
          textX = 335;
        } else {
          textY = 465;
          textX = 165;
        }


        let line0 = score + " %";
        let line1 = categories[key].question.toUpperCase();


        let line2 = "";

        if (line1.indexOf("&") !== -1) {
          line1 = line1.split("&");
          line2 = line1[1];
          line1 = line1[0] + "&";
        }

        if (line1.indexOf("VOORTDUREND") !== -1) {
          line1 = line1.split("VOORTDUREND");
          line2 = line1[1];
          line1 = line1[0] + "VOORTDUREND";
        }


        //        categories[key].question.toUpperCase() + " " + score + "%";
        return (
          <>


            <VectorText
              x={textX}
              y={textY}
              text={line1}


              textAnchor="middle"
              fill="#000"
              fontFamily="Verdana"
              fontWeight="bold"
              textAlign="left"

              transform={`rotate(${adjustedTextAngle}, ${textX}, ${textY})`} // Rotate the text*/

              fontSize="12"
            >

              {line1}


            </VectorText>


            <VectorText
              x={textX}
              y={textY + 15}

              text={line2}
              textAnchor="middle"
              fill="#000"
              fontFamily="Verdana"
              fontWeight="bold"
              textAlign="left"

              transform={`rotate(${adjustedTextAngle}, ${textX}, ${textY + 15})`} // Rotate the text*/

              fontSize="12"
            >

              {line2}


            </VectorText>

            <VectorText
              x={textX}
              y={textY + 30}
              text={line0}

              textAnchor="middle"
              fill="#000"
              fontFamily="Verdana"
              fontWeight="bold"
              textAlign="left"

              transform={`rotate(${adjustedTextAngle}, ${textX}, ${textY + 30})`} // Rotate the text*/

              fontSize="12"
            >

              {line0}


            </VectorText>
          </>
        );
      })}

    </>
  );

}

export default Slice;






